import Typography from '@material-ui/core/Typography';
import React from 'react';

const PageSubTitle = ({ text }) => {
  return <Typography variant="body1">{text}</Typography>;
};

export default PageSubTitle;
